export default __webpack_public_path__ + "static/media/NBA.fb972188.jpg";